export enum TipoReporte {
	estados = 'est',
	depatamentos = 'dep',
	categorias = 'cat'
}

